import { IdsAdapterService, LanguagesService, ProjectService } from '@alpha-core/platform-ui';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { userService } from '../../services/user-service';
import { PrimeNGModules } from '../../shared/alpha-shared.module';
import { DialogComponent } from '../dialog/dialog.component';
import { PaginationBarComponent } from '../pagination-bar/pagination-bar.component';
import { JoinPipe } from './joinpipe/join.pipe';
import { Uma } from './user.types';

@Component({
    selector: 'app-users',
    standalone: true,
    providers: [DialogService],
    templateUrl: './users.component.html',
    imports: [PrimeNGModules, PaginationBarComponent, JoinPipe, TranslatePipe],
})
export class UsersComponent implements OnInit, OnDestroy {
    private userService = inject(userService);
    private router = inject(Router);
    private dialogService = inject(DialogService);
    private messageService = inject(MessageService);
    private projectService = inject(ProjectService);
    private languageService = inject(LanguagesService);
    private idsAdapterService = inject(IdsAdapterService);

    private searchSubject$ = new Subject<void>();
    private destroy$ = new Subject<void>();

    addButtonActions = [
        // {
        //   label: 'Import'
        // },
        {
            label: 'default-cm-create',
        },
    ];

    sortStatus: 'asc' | 'desc' = 'asc';
    sort: { [key: string]: boolean } = { user_id: false };
    //filter functionalies
    filter: {
        pageSize: number;
        page: number;
        totalCount: number;
        searchKey: string;
    } = { pageSize: 10, page: 0, totalCount: 0, searchKey: '' };
    usersData: Uma[] = [];
    allUsers: Uma[] = [];

    actionsOptions = [
        {
            label: 'default-cm-edit',
            icon: 'assets/icons/edit-button.svg',
            command: () => {
                this.navigateTo('home/users/update-user');
            },
        },
        // {
        // 	label: 'default-cm-delete',
        // 	icon: 'assets/icons/delete-button.svg',
        // 	command: () => {
        // 		this.disableUser(this.user);
        // 	},
        // },
    ];
    ngOnInit(): void {
        this.filter.pageSize = this.userService.userPageSize || this.filter.pageSize;
        this.searchSubject$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(() => {
            this.filter.page = 0;
            this.fetchAllUsers();
        });
        this.fetchAllUsers();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    fetchAllUsers(options?: { sortBy?: string; sortOrder?: 'asc' | 'desc' }) {
        this.idsAdapterService
            .fetchAllUsers(
                {
                    pageSize: this.filter.pageSize,
                    pageNumber: this.filter.page,
                    search: this.filter.searchKey,
                    sortBy: options?.sortBy,
                    sortOrder: options?.sortOrder,
                },
                false,
            )
            .then((data: any) => {
                this.usersData = data.umas;
                this.allUsers = data.umas;
                this.filter.totalCount = data.totalCount;
            });
    }

    triggerSelect(item: any, dropdown: any) {
        if (item.label == 'default-cm-create') {
            localStorage.removeItem('updateUser');
            this.navigateTo('home/users/create-user');
        }
        dropdown.hide();
    }

    customSort(field: string) {
        if (this.sort[field]) {
            this.sortStatus = this.sortStatus === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortStatus = 'asc';
            this.sort[field] = true;
            Object.keys(this.sort).forEach((sortKey) => {
                if (sortKey !== field) {
                    this.sort[sortKey] = false;
                }
            });
        }
        this.fetchAllUsers({ sortBy: field, sortOrder: this.sortStatus });
    }

    user!: Uma;
    openToggleMenu(menu: any, user: any, event: any) {
        this.user = user;
        event.preventDefault();
        event.stopPropagation();
        menu.toggle(event);
        localStorage.setItem('updateUser', JSON.stringify(user));
    }

    changePageSize(event: any) {
        if (event.value) {
            this.filter.pageSize = this.userService.userPageSize = event.value;
            this.filter.page = 0;
            this.fetchAllUsers();
        }
    }

    paginationChange(filter: any) {
        this.fetchAllUsers();
    }

    disableUser(user: Uma) {
        this.dialogService
            .open(DialogComponent, {
                data: {
                    dialogType: 'confirm',
                },
                header: this.languageService.getTranslation('default-cm-confirm') || 'Confirm',
                width: '35rem',
            })
            .onClose.subscribe((data: any) => {
                if (data) {
                    this.userService
                        .disableUser(user)
                        .then(() => {
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Disabled!',
                                detail: `User ${user.user_id} has been disabled.`,
                            });
                            this.fetchAllUsers();
                        })
                        .catch((error) => {
                            this.messageService.add({
                                severity: 'error',
                                summary: error?.error?.message || 'error',
                                detail: error?.error?.stack?.message || 'Internal error',
                            });
                        });
                }
            });
    }

    navigateTo(path: string) {
        const project = this.projectService.fetchCurrentProject();
        this.router.navigate([path], {
            queryParams: {
                projectId: project?.projectId,
            },
        });
    }

    searchUsers() {
        this.filter.searchKey = this.filter.searchKey.toLowerCase();
        this.searchSubject$.next();
    }
}
